import Vue from 'vue'
import Router from 'vue-router' 
import HomeComponent from '@/components/homeComponent.vue' 
import worksComponent from '@/components/worksComponent.vue'
import videoComponent from '@/components/videoComponent.vue'
import contactComponent from '@/components/contactComponent.vue'
import serviceComponent from '@/components/serviceComponent.vue'
import whiteWood from '@/components/works/bungalow/whiteWood.vue'
import romanceInTheHouse from '@/components/works/semi-d/romanceInTheHouse.vue'
import perfectInBlack from '@/components/works/semi-d/perfectInBlack.vue'
import guiHome from '@/components/works/semi-d/guiHome.vue'
import muGuang from '@/components/works/link-house-condo/muGuang.vue'
import comfortZone from '@/components/works/link-house-condo/comfortZone.vue'
import greySong from '@/components/works/link-house-condo/greySong.vue'
import serenityLinkHouse from '@/components/works/link-house-condo/serenityLinkHouse.vue'
import sakuraLinkHouse from '@/components/works/link-house-condo/sakuraLinkHouse.vue'
import cloud from '@/components/works/link-house-condo/cloud.vue'
import blue from '@/components/works/link-house-condo/blue.vue'
import jade from '@/components/works/link-house-condo/jade.vue'
import coloursLinkHouse from '@/components/works/link-house-condo/coloursLinkHouse.vue'
import rock from '@/components/works/link-house-condo/rock.vue'
import notfound from '@/components/404.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeComponent
    },
    {
      path: '/Home',
      name: 'Home',
      component: HomeComponent
    },
    {
      path: '/works',
      name: 'works',
      component: worksComponent
    },
    {
      path: '/video',
      name: 'video',
      component: videoComponent
    },
    {
      path: '/contact',
      name: 'contact',
      component: contactComponent
    },
    {
      path: '/service',
      name: 'service',
      component: serviceComponent
    },
    {
      path: '/White-Wood',
      name: 'White-Wood',
      component: whiteWood
    },
    {
      path: '/Romance-In-The-House',
      name: 'Romance-In-The-House',
      component: romanceInTheHouse
    },
    {
      path: '/Perfect-In-Black',
      name: 'Perfect-In-Black',
      component: perfectInBlack
    },
    {
      path: '/Gui-Home',
      name: 'Gui-Home',
      component: guiHome
    },
    {
      path: '/Mu',
      name: 'Mu',
      component: muGuang
    },
    {
      path: '/Comfort-Zone',
      name: 'Comfort-Zone',
      component: comfortZone
    },
    {
      path: '/Grey-Song',
      name: 'Grey-Song',
      component: greySong
    },
    {
      path: '/Serenity',
      name: 'Serenity',
      component: serenityLinkHouse
    },
    {
      path: '/Sakura',
      name: 'Sakura',
      component: sakuraLinkHouse
    },
    {
      path: '/Cloud',
      name: 'Cloud',
      component: cloud
    },
    {
      path: '/Blue',
      name: 'Blue',
      component: blue
    },
    {
      path: '/Jade',
      name: 'Jade',
      component: jade
    },
    {
      path: '/Colours',
      name: 'Colours',
      component: coloursLinkHouse
    },
    {
      path: '/Rock',
      name: 'Rock',
      component: rock
    } ,
    {
      path: '/404',
      name: '404',
      component: notfound
    } ,
    {
      path: '*',
      redirect: '/404'
    }
    
  ], scrollBehavior( ) { 
    return { x: 0, y: 0 };
  },
})
 